import { render, staticRenderFns } from "./roleManager.vue?vue&type=template&id=38ec1da2&scoped=true&"
import script from "./roleManager.vue?vue&type=script&lang=js&"
export * from "./roleManager.vue?vue&type=script&lang=js&"
import style0 from "./roleManager.vue?vue&type=style&index=0&id=38ec1da2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec1da2",
  null
  
)

export default component.exports